var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgApprovalDelegation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_479_474816)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.45313 4.96875L4.89062 2.40625L5.5625 1.73438L7.45313 3.64063L11.1094 0L11.7656 0.640625L7.45313 4.96875ZM8.21875 12.2969L3.35938 10.9063V11.7969H0V5.64062H4.82813L8.8125 7.14062C9.09375 7.24479 9.33073 7.41406 9.52344 7.64844C9.71615 7.88281 9.8125 8.21875 9.8125 8.65625H11.5937C12.0312 8.65625 12.3958 8.8125 12.6875 9.125C12.9792 9.4375 13.125 9.85937 13.125 10.3906V10.7969L8.21875 12.2969ZM0.9375 10.8594H2.40625V6.57812H0.9375V10.8594ZM8.15625 11.3281L12.1563 10.1094C12.0938 9.91146 12.0156 9.77604 11.9219 9.70312C11.8281 9.63021 11.7187 9.59375 11.5937 9.59375H8.35938C8.04688 9.59375 7.75781 9.57292 7.49219 9.53125C7.22656 9.48958 6.97396 9.43229 6.73437 9.35938L5.46875 8.96875L5.8125 8.0625L6.95312 8.4375C7.21354 8.52083 7.46094 8.57812 7.69531 8.60937C7.92969 8.64062 8.30208 8.65625 8.8125 8.65625C8.8125 8.53125 8.78906 8.40885 8.74219 8.28906C8.69531 8.16927 8.61458 8.08333 8.5 8.03125L4.67188 6.57812H3.35938V9.92188L8.15625 11.3281Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_479_474816"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 13,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApprovalDelegation);
export default __webpack_public_path__ + "static/media/approval-delegation.28536f5b02c63f51ad1dfc2790829dba.svg";
export { ForwardRef as ReactComponent };